import { Link } from '@tanstack/react-router';


/**
 * The ink strip above the header. In the mockup the trailing link is a
 * coloured `<span>` that goes nowhere, which is a dark pattern in a bar whose
 * whole job is to be clicked — it is a real link here.
 */
export function AnnouncementBar() {
    return (
        <div className="mn-on-ink w-full bg-background px-4 py-2 text-center font-mono text-[11px] tracking-[0.06em] text-foreground">
            Taking on a limited number of practices this quarter{' '}
            <span aria-hidden="true">→</span>{' '}
            <Link
                to="/login"
                className="text-primary underline underline-offset-4 transition-colors duration-200 hover:text-foreground"
            >
                talk to us
            </Link>
        </div>
    );
}
